import {ColumnsEdit} from "types/models/column-table-edit";
import React from "react";
import {ColumnProps} from "../../../../../../../../types/models";
const TypeOfContractColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    align: "center",
    fixed: "left",
    width: 60,
    isResizable: true,
  },

  {
    title: "Mã loại",
    key: "maLoai",
    show: true,
    dataIndex: "maLoai",
    width: 100,
   align: "left",
   isResizable: true,
   
  },
  {
    title: "Tên loại",
    key: "tenLoai",
    show: true,
    dataIndex: "tenLoai",
    width: 150,
   align: "left",
   isResizable: true,
  },
  {
    title: "Mã cấu hình nghỉ phép",
    key: "maNghiPhep",
    show: true,
    dataIndex: "maNghiPhep",
    width: 100,
   align: "left",
   isResizable: true,

  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: true,
    dataIndex: "ghiChu",
    width: 150,
   align: "left",
   isResizable: true,
  },

  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    editable: true,
    width: 140,
    show: true,
    align: "center",
  },
];

export {TypeOfContractColumns};
